/** Settings -> Planning -> Jurisdiction boundary: file upload, Library layer picker, map preview and facts. */
export default {
  boundary: 'Jurisdiction boundary',
  boundaryHint:
    'A polygon in WGS 84 (EPSG:4326) from a GeoJSON file or a Library layer, up to 1,000,000 characters of GeoJSON. A site outside it fails the check.',
  boundaryUpload: 'Upload GeoJSON',
  boundaryRemove: 'Remove boundary',
  boundaryNone: 'No boundary: checks warn that the jurisdiction is not configured.',
  boundarySummary: '{{type}} with {{vertices}} vertices',
  boundaryMap: 'Map of the jurisdiction boundary',
  boundaryArea: 'Area: {{area}} km²',
  boundaryExtent: 'Extent: longitude {{minLon}} to {{maxLon}}, latitude {{minLat}} to {{maxLat}}',
  boundaryWarnings: {
    very_small: 'This area is very small for a jurisdiction (under 0.5 km²). Check that it is the right boundary.',
    very_large: 'This area is very large for a jurisdiction (over 50,000 km²). Check that it is the right boundary.',
  },
  boundarySource: {
    file: 'From file {{name}}',
    layerFeature: 'From layer {{layer}}, feature {{feature}}',
    layerAll: 'From layer {{layer}}, all features',
    noId: 'This feature has no id, so it cannot be refreshed from the layer.',
  },
  boundaryRefresh: 'Refresh from layer',
  boundaryRefreshing: 'Refreshing…',
  boundaryRefreshed: 'Refreshed from the layer. Save to keep it.',
  boundaryLayer: {
    open: 'Use a feature from a layer',
    layer: 'Polygon layer',
    chooseLayer: 'Choose a layer',
    loadingLayers: 'Loading layers…',
    layersFailed: 'The Library layers could not be loaded.',
    noLayers: 'The Library has no polygon layers you can use.',
    layersCapped: 'Only the first {{limit}} Library layers were searched.',
    noLayersCapped: 'None of the first {{limit}} Library layers is a polygon layer you can use.',
    loadingFeatures: 'Loading features…',
    featuresFailed: 'This layer could not be read. Try again or choose another layer.',
    noFeatures: 'This layer has no polygon features.',
    labelField: 'Label attribute',
    feature: 'Feature',
    chooseFeature: 'Choose a feature',
    allFeatures: 'All features in this layer',
    unnamed: 'Feature {{n}}',
    featuresCapped: 'Only the first {{limit}} features are listed, and "All features" combines only these.',
    noIdWarning: 'This feature has no id, so it cannot be refreshed from the layer later.',
    use: 'Use this boundary',
    cancel: 'Cancel',
  },
  boundaryErrors: {
    too_large:
      'The boundary is too detailed: it is over 1,000,000 characters of GeoJSON. Pick a smaller feature or simplify it.',
    file_too_large: 'The file is larger than 10 MB.',
    invalid_json: 'The file is not valid JSON.',
    no_polygon: 'No polygon or multipolygon was found.',
    bad_coordinates: 'The coordinates are not longitude and latitude in WGS 84.',
    fetch_failed: 'The layer could not be read. Try again later.',
    feature_gone: 'The feature is no longer in the layer (only its first 1,000 features are searched).',
    not_refreshable: 'This feature has no id, so it cannot be refreshed from the layer.',
  },
} as const
